import auth from '../api/auth.api'
import store from './index.js'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  isLogged: false,
  loginError: null,
  lostLoginError: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  login (state) {
    state.isLogged = true
  },
  logout (state) {
    state.isLogged = false
  },
  addLoginError (state, error) {
    state.loginError = error
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  directLogin (context, token) {
    localStorage.setItem('key', token)
    store.dispatch('getUserDetails')
    context.commit('login')
  },
  logUser (context, loginDatas) {
    auth.api.login(loginDatas[0], loginDatas[1])
    .then(response => {
      localStorage.setItem('key', response.data.key)
      store.dispatch('getUserDetails')
      context.commit('login')
      context.commit('addLoginError', null)
    },
    error => {
      console.log('error when trying to log in : ' + error.status)
      context.commit('addLoginError', error.status)
    })
  },
  logOut (context) {
    auth.api.logout()
    .then(repsonse => {
      localStorage.removeItem('key')
      context.commit('logout')
      store.dispatch('removeUser')
    },
    error => {
      console.log('error when trying to log in : ' + error.status)
      context.commit('addLoginError', error.status)
    })
  },
  checkToken (context) {
    let tok = localStorage.getItem('key')
    if (tok !== null && tok !== 'undefined') {
      auth.api.checkToken()
        .then(response => {
          context.commit('login')
          console.log('Token vérifié')
          store.dispatch('getUserDetails')
        },
        error => {
          console.log('error trying to check token : ' + error)
        })
    }
  }

}
// getters are functions
const getters = {
  isLogged: state => {
    return state.isLogged
  },
  loginError: state => {
    return state.loginError
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/auth.js